export default "__VITE_ASSET__N2XLnXv$__"